/**
 * Used for tracking user events from the browser. Currently pushes the data into GTM & snowPlow.
 * Written to be extensible and be used by CAM4Analytics later on
 *
 * @class TrackingService
 */
class TrackingService {
  /**
   * Creates an instance of TrackingService.
   * Intantiates dataLayer global var if not already available and tracks basic domain attributes
   * @memberof TrackingService
   */
  constructor() {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
  }

  /**
   * Tracks basic domain attributes
   * @memberof TrackingService
   */
  trackDomain = () => {
    this.track({ Domain: window.location.hostname.substr(window.location.hostname.indexOf('.')) });
    this.track({ Subdomain: window.location.hostname });
    this.track({ Responsive: 'true' });
  };

  /**
   * Tracks user data
   * @param {Object} userInfo  - User object received from /logi/user
   * @memberof TrackingService
   */
  trackUserData = (userInfo) => {
    this.track({ 'User Level': `${userInfo.accessLevel}` });
    if (userInfo.affiliateCode) {
      this.track({ 'Advertising Code': `${userInfo.affiliateCode}` });
    }

    if (userInfo.username) {
      this.track({ Gender: `${userInfo.gender}` });
      this.track({ Sexuality: `${userInfo.genderPreference}` });
      this.track({ Member: 'yes' });
      this.track({ 'Logged In': 'yes' });
      this.track({ Created: `${userInfo.created}` });
      this.track({ 'Has Membership Bonus': `${userInfo.paymentInfo?.hasMembershipBonus || false}` });
      this.track({ 'Has Purchases': `${userInfo.paymentInfo?.hasPurchases || false}` });
      this.track({ 'Is Performer': `${Boolean(userInfo.isPerformer)}` });
      this.track({ Username: `${userInfo.username}` });
      this.track({ uid: `${userInfo.gaUserUid}` });
    }

    if (window._vwo_exp_ids && Array.isArray(window._vwo_exp_ids) && window._vwo_exp_ids.length > 0) {
      window._vwo_exp_ids.forEach((el) => {
        const currentExperiment = window._vwo_exp[el];
        if (currentExperiment.segment_eligble) {
          this.track({
            eventCategory: 'vwo',
            eventAction: currentExperiment.name,
            eventLabel: `variation ${currentExperiment.cc}`,
          });
        }
      });
    }
  };

  /**
   * Reusable tracking method used for sending new values to the server.
   * Currently only dataLayer is supported
   * @param {Object} input - Tracking information object single key & value. Example this.track({'Logged In' : 'yes'});
   * @memberof TrackingService
   */
  track = (input) => {
    window.dataLayer.push(input);
  };
}

/**  Export default as a single instance */
export default new TrackingService();
